import { useEffect, useState } from "react";
import { Image } from "../../../Image/Image";
import { FicheType } from "../../FicheType/FicheType";
import { MoreInfo } from "../../MoreInfo/MoreInfo";
import "./FicheGSportkamp.scss";

export const FicheGSportkamp = (props) => {
  const [bodyItems, setBodyItems] = useState(null);

  // Process body items
  useEffect(() => {
    if (props.data.body && props.data.body.items) {
      let items = props.processFicheItems(props.data.body.items);
      setBodyItems(items);
    }
  }, [JSON.stringify(props.data.body?.items)]);

  // Determine if we have a valid image
  const hasImage = props.data.ficheImage?.url || props.data.image?.url;
  const imageUrl = props.data.ficheImage?.url || props.data.image?.url;

  return (
    <div className="c-fiche c-gsportkamp" data-aos="fade-up">
      <div>
        {/* Date bar above image */}
        {props.data.type && (
          <FicheType type={props.data.type}>
            <i className="fa-fw fa-fw fas fa-calendar-alt"></i>
          </FicheType>
        )}

        {/* Image with placeholder fallback */}
        <div className="image" title={props.data.title}>
          {hasImage ? (
            <Image alt={props.data.title} src={imageUrl} />
          ) : (
            <div className="image-placeholder">
              <i className="fa-solid fa-image"></i>
            </div>
          )}
        </div>

        {/* Header with title */}
        <header className="c-fiche__header">
          <h2 className="title" title={props.data.title}>
            {props.data.title}
          </h2>
        </header>

        {/* Body items with icons */}
        <div className="c-fiche__body">
          <ul>{bodyItems}</ul>
        </div>

        {/* More info button - opens in new tab */}
        {props.data.link && (
          <MoreInfo
            data={{ hasDetail: true, title: props.data.title }}
            url={props.data.link}
            cta={props.data.linkText || "Meer info"}
            target={props.data.target || "_blank"}
          />
        )}
      </div>
    </div>
  );
};
